<template>
  <div class="header">
    <div class="header_content">
      <!-- header -->
      <div class="content">
        <h4>{{ navTitle }}</h4>
        <div class="title">{{ navTip }}</div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    navTitle: String,
    navTip: String,
  },
});
</script>

<style lang="scss" scoped>
.header {
  min-height: 100px;
  position: relative;
  .header_content {
    background: #5374e8;
    min-height: 100px;
    position: relative;
    .content {
      padding: 10px 0;
      margin: auto;
      left: 0;
      right: 0;
      top: 20px;
      h4 {
        width: 320px;
        margin: auto;
        color: #fff;
      }
      .title {
        font-size: 12px;
        color: #fff;
        width: 320px;
        margin: 10px auto;
      }
    }
  }
}
</style>
